import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";

import store from "./store";

const app = (
	<Provider store={store}>
		<App />
	</Provider>
);

const element = document.getElementById("root");
const root = createRoot(element);

root.render(app);